import { render, staticRenderFns } from "./Phase3.vue?vue&type=template&id=224407d1&"
import script from "./Phase3.vue?vue&type=script&lang=js&"
export * from "./Phase3.vue?vue&type=script&lang=js&"
import style0 from "./Phase3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Phase3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports